import React, { useState, useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import questions from "../questiondatas/cdpquestions";
import axios from "axios";  
import Modal from '../resultcomponent/ModalBox';
import "./cdpfeedback.css";
const logoSrc = "../UNextLogo2.png";
const CdpFeedback = () => {
  const username = localStorage.getItem("username");
  const email = localStorage.getItem("email");
  
  const [responses, setResponses] = useState(Array(questions.length).fill(null));
  const [error, setError] = useState(false);
  const [hasSubmitted, setHasSubmitted] = useState(false);
 
useEffect(() => {
    document.title = "Competency Development Program"; // Change browser tab title

    return () => {
      document.title = "UNext Learning Pvt Ltd"; // Reset title when component unmounts
    };
  }, []);
const [timeLeft, setTimeLeft] = useState(() => {
  const storedStartTime = sessionStorage.getItem("startTime");
  const currentTime = Date.now();
  if (!storedStartTime) {
   // const currentTime = Date.now();
    sessionStorage.setItem("startTime", currentTime.toString());
    return 1200; // Start with 20 minutes
  }
  const elapsed = Math.floor((Date.now() - parseInt(storedStartTime, 10)) / 1000);
    return Math.max(1200 - elapsed, 0);
  });
  


const navigate = useNavigate();




useEffect(() => {
  if (timeLeft <= 0) {
   // alert("Your time has expired. You will be logged out.");
   setModalMessage("Your time has expired. You will be logged out."); 
   setIsModalVisible(true);
   //sessionStorage.clear(); // Clear all session-related data
    //navigate("/logout");
    return;
  }

  const interval = setInterval(() => {
    setTimeLeft((prevTime) => Math.max(prevTime - 1, 0));
  }, 1000);

  return () => clearInterval(interval); // Cleanup on component unmount
}, [timeLeft, navigate]);





  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [pendingSubmission, setPendingSubmission] = useState(false);
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState(""); // State for error message

  
  const handleModalConfirm = async () => {
    setIsModalVisible(false);

    if (modalMessage === "Your time has expired. You will be logged out.") {
      sessionStorage.clear();
      navigate("/cdplogout");
    }

    if (pendingSubmission) {
      try {
        const payload = {
          email,
          responses: questions.map((question, index) => ({
            questionId: question.id,
            rating: responses[index],
          })),
        };
        await axios.post("/api/submit-cdp", payload);
        setModalMessage("Survey submitted successfully!");
        setIsSuccessModalVisible(true);
        sessionStorage.removeItem("timeLeft");
        
       // const startTime = localStorage.getItem("startTime");
       
        navigate("/cdplogout", { state: { responses} });
      } catch (err) {
        console.error("Error submitting cdp data:", err);
       // alert("An error occurred while submitting the survey. Please try again.");
        setModalMessage("An error occurred while submitting the cdp data. Please try again.");
        setIsModalVisible(true);

      }
    }
  };

  const handleSuccessModalConfirm = () => {
    setIsSuccessModalVisible(false);
    const startTime = sessionStorage.getItem("startTime");
    navigate("/cdplogout", { state: { responses ,startTime:startTime } });
  };

  const handleSubmit = useCallback(
    (event) => {
      if (event) event.preventDefault();
      setHasSubmitted(true);

      if (responses.some((response) => response === null)) {
       
       setModalMessage("Please provide a response to all the questions.");
      setIsModalVisible(true);
        return;
      }

      setError(false);
      setModalMessage("Click OK to proceed");
      setPendingSubmission(true);
      setIsModalVisible(true);
    },
    [responses]
  );

  /*useEffect(() => {

    if (timeLeft <= 0); 
      
      
      {
      alert("Your time has expired. You will be logged out.");
      localStorage.removeItem("username");
      localStorage.removeItem("email");
      localStorage.removeItem("timeLeft");
      navigate("/logout", {
        state: { message: "You were logged out due to time expiry." },
      });
      
    }




    const timer = setInterval(() => {
      setTimeLeft((prevTime) => {
        const newTime = prevTime - 1;
        localStorage.setItem("timeLeft", newTime);
        return newTime;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft, navigate]);


  */


  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return (
      <span>
        <span style={{ color: "orange" }}>{minutes.toString().padStart(2, "0")}</span>
        <span style={{ color: "orange" }}>:{secs.toString().padStart(2, "0")}</span>
      </span>
    );
  };

  const handleChange = useCallback(
    (index, value) => {
      const updatedResponses = [...responses];
      updatedResponses[index] = value ? parseInt(value, 10) : null;
      setResponses(updatedResponses);
    },
    [responses]
  );
  const handleModalCancel = () => {
    setIsModalVisible(false);
    setPendingSubmission(false);
  };
  return (

    <div className="feedback-form-wrapper">
      <div className="feedback-top-left-instructions">
        <h4>Providing feedback</h4>
        <p>
        Please provide your feedback for the reflection points on the below scale:
        </p>
        <ul style={{ listStyle: "none", padding: 0, margin: 0}}>
          <li  style={{ marginBottom: "5px",fontSize:"0.9em"  }}>1- Rarely/Never</li>
          <li  style={{ marginBottom: "5px",fontSize:"0.9em"  }}>2- Occasionally</li>
          <li  style={{ marginBottom: "5px",fontSize:"0.9em"  }}>3- Sometimes</li>
          <li  style={{ marginBottom: "5px",fontSize:"0.9em"  }}>4- Often</li>
          <li  style={{ marginBottom: "5px",fontSize:"0.9em"  }}>5- Always</li>

        </ul>
              </div>

      <div className="feedback-form-page">
        <header className="feedback-header">
          <h4 className="feedback-heading">Competency Development Program</h4>
     {/* New text section added here */}
  <div className="program-description">
  <p>bhushan@gmail.com's 180-degree assessment for evaluating Strengths & Opportunities</p>
</div>

          <div className="feedback-logo-container">
            <img src={logoSrc} alt="Logo" className="feedback-logo" />
          </div>
          <div className="feedback-welcome-message">Welcome  {username || "Guest"}</div>
        </header>

        <form onSubmit={handleSubmit} className="feedback-form">
          <div className="feedback-questionnaire">
            <div className="feedback-questions-container">
              <table className="feedback-table">
                <thead>
                  <tr>
                    <th>Sr.#</th>
                    <th>Competency</th>
                    
                    <th>Reflection Point</th>
                    <th>Feedback</th>
                  </tr>
                </thead>
                <tbody>
                  {questions.map((question, index) => (
                    <tr key={question.id}>
                      <td>{question.id}</td>
                      <td>{question.category}</td>
                      
                      <td>{question.text}</td>
                      <td>
                        <select
                          value={responses[index] || ""}
                          onChange={(e) => handleChange(index, e.target.value)}
                          aria-label={`Rating for question ${question.id}`}
                        >
                          <option value="" disabled>Please Choose</option>
                          {[1, 2, 3, 4, 5].map((value) => (
                            <option key={value} value={value}>{value}</option>
                          ))}
                        </select>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <button type="submit" className="feedback-submit-button">Submit</button>
          
          {hasSubmitted && error && <p className="feedback-error-message">Please provide a response to all the questions.</p>}
        
         </form>

        <div className="feedback-timer">Time Remaining: {formatTime(timeLeft)}</div>
      </div>

      {/* Modal */}
      {isModalVisible && (
        <Modal
          message={modalMessage}
          onConfirm={handleModalConfirm}
          onCancel={handleModalCancel}
          hideCancelButton={modalMessage === "Your time has expired. You will be logged out." ||
            modalMessage === "Please provide a response to all the questions."} // Hide cancel button for time expiry alert
          />
      )}

      {/* Success Modal */}
      {isSuccessModalVisible && (
        <Modal
          message={modalMessage}
          onConfirm={handleSuccessModalConfirm}
          hideCancelButton={true}
        />
      )}


      {/* Footer */}
      <div className="feedback-footersurvey">
   © {new Date().getFullYear()} UNext Learning Pvt Ltd&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp; &nbsp;  &nbsp; &nbsp;  &nbsp; &nbsp;  &nbsp; &nbsp;  &nbsp; &nbsp;  &nbsp;
      </div>
    
      </div>
    
  );
};

export default CdpFeedback;
